
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/clinician/support.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import ConfluenceArticle from '@components/UI/ConfluenceArticle';
import Header from '@components/Layouts/Header/Header';

const Support = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();
  const {
    query: { id = 'CONF_CLIN_SUPPORT' }
  } = useRouter();

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <>
      <Header pageType="clinician" pageTitle="Clinician Support" />

      <section className="section-layout">
        <main className="container" id="page-content">
          <ConfluenceArticle id={String(id)} />
        </main>
      </section>
    </>
  );
};

export default Support;
export const Route = createFileRoute('/clinician/support')({ component: Support });
